import React, { useState, useRef, useEffect } from "react";
import postscribe from 'postscribe';
// Components
import { Steps, Flex, Row, Col, Form } from "antd";
// import CreatePassword from './CreatePassword';
import Couriers from "./Couriers";
import Products from "./Products";
import Sensors from "./Sensors";
import Users from "./Users";
import Notifications from "./Notifications";
import CustomButton from "../../../components/CustomButton";
import { SubmitSettingsProfile } from "../../../api's/settings";
import { useToken } from '../../../common/helper';
// Styles
import "./Steps.scss";
import { useNavigate } from "react-router-dom";
import LocationMap from "./LocationsMap";
import NotificationsSetup from "./NotificationsSetup";

const { Step } = Steps;

const steps = [

  // { title: 'Create Password', content: CreatePassword },
  { title: "Transport", content: Couriers },
  { title: "Products", content: Products },
  { title: "Sensors", content: Sensors },
  { title: "Locations", content: LocationMap },
  { title: "Users", content: Users },
  { title: "Notifications", content: Notifications },
];

const OnboardingSteps = () => {

  const { token, removeToken, decodedUserToken } = useToken();
  const decodedToken = decodedUserToken();
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const productsFormRef = useRef(null);

  const navigate = useNavigate();

  const next = async () => {
    if (productsFormRef?.current?.completeStep) {
      const success = await productsFormRef.current.completeStep();
      if (!success) return; // stop here if form failed
    }
    if (current < steps.length - 1) {
      setCurrent(current + 1);
    } else if (current === steps.length - 1) {
      navigate("/confirmation");
    }
  };


  const RefreshAccount = (token) => {
    let refresh = localStorage.getItem('@token');
    SubmitSettingsProfile(refresh, {})
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            localStorage.setItem("@token", res?.data?.data?.access_token);
          }
        }
      })
      .catch((error) => {
      })
      .finally(() => {
      });

  }




  const targetElement = document.getElementById('root');
  useEffect(() => {
 let obj={username:"",companyname:""};
    if (targetElement) {
        obj={
        username:decodedToken?.name || "",
        companyname:decodedToken?.company_name || ""
      }
      // const scriptContent = `
      //       <script type="text/javascript">
      //         (function(w, d, x, id){
      //           s=d.createElement('script');
      //           s.src='https://db08fjupg2abb.cloudfront.net/amazon-connect-chat-interface-client.js';
      //           s.async=1;
      //           s.id=id;
      //           d.getElementsByTagName('head')[0].appendChild(s);
      //           w[x] =  w[x] || function() { (w[x].ac = w[x].ac || []).push(arguments) };
      //         })(window, document, 'amazon_connect', 'c10b159f-c584-4f49-8192-66738e4be615');
      //         amazon_connect('styles', { iconType: 'CHAT', openChat: { color: '#ffffff', backgroundColor: '#123456' }, closeChat: { color: '#ffffff', backgroundColor: '#123456'} });
      //         amazon_connect('snippetId', 'QVFJREFIZ2ZYaENvQWJCb1ZtYmxRNlFMNVJYMlhab3BKY1p0RnRGQ2pJNGhxdnBvemdIdEZVL2xnY0dRRzZrNjRPN2NlcnVVQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNTmFPaUlFdXRWMkkwZUdUTEFnRVFnQ3RZZEZmdFdqcjd0RjNMczd4ZFY0bitWN1l2d1I2WXQ5azNsd3BMZW52K0pZc3dKT3hTNzJSTStNUnM6Om9oVElDQTBndVl6YXJKQlJVZ2pSRVNXUTZzS0UwT0tHUHR6N2xVaEhjaHVYNHhiUkE5UGs4Y1FtMGJ5NG1iK0gya2s2bnl5dlBhQmVVQkl5Wnhsd0xKOENld0lLQmVjZnByS2lVT3dIS0dreUNJNjJBN2hQUG5iV1pveXdnbHVWTUJzTnV0S0xZQ3NKdThmdklMMjRwa2JQK3dGcm9raz0=');
      //         amazon_connect('supportedMessagingContentTypes', [ 'text/plain', 'text/markdown', 'application/vnd.amazonaws.connect.message.interactive', 'application/vnd.amazonaws.connect.message.interactive.response' ]);
      //       </script>
      //     `;
      const scriptContent = `
          <script type="text/javascript">
  (function(w, d, x, id){
    s = d.createElement('script');
    s.src = 'https://zoomlogiconnect.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js';
    s.async = 1;
    s.id = id;
    d.getElementsByTagName('head')[0].appendChild(s);
    w[x] = w[x] || function() { (w[x].ac = w[x].ac || []).push(arguments) };
  })(window, document, 'amazon_connect', 'c10b159f-c584-4f49-8192-66738e4be615');

  amazon_connect('styles', {
    iconType: 'CHAT',
    openChat: { color: '#ffffff', backgroundColor: '#266ef1' },
    closeChat: { color: '#ffffff', backgroundColor: '#266ef1' }
  });

  amazon_connect('snippetId', 'QVFJREFIZ2ZYaENvQWJCb1ZtYmxRNlFMNVJYMlhab3BKY1p0RnRGQ2pJNGhxdnBvemdIdEZVL2xnY0dRRzZrNjRPN2NlcnVVQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNTmFPaUlFdXRWMkkwZUdUTEFnRVFnQ3RZZEZmdFdqcjd0RjNMczd4ZFY0bitWN1l2d1I2WXQ5azNsd3BMZW52K0pZc3dKT3hTNzJSTStNUnM6Om9oVElDQTBndVl6YXJKQlJVZ2pSRVNXUTZzS0UwT0tHUHR6N2xVaEhjaHVYNHhiUkE5UGs4Y1FtMGJ5NG1iK0gya2s2bnl5dlBhQmVVQkl5Wnhsd0xKOENld0lLQmVjZnByS2lVT3dIS0dreUNJNjJBN2hQUG5iV1pveXdnbHVWTUJzTnV0S0xZQ3NKdThmdklMMjRwa2JQK3dGcm9raz0=');
//Change this dynamically
  amazon_connect('customerMetadata', {
    name: '${obj?.username}',
    company: '${obj.companyname}'
  });

  amazon_connect('supportedMessagingContentTypes', [
    'text/plain',
    'text/markdown',
    'application/vnd.amazonaws.connect.message.interactive',
    'application/vnd.amazonaws.connect.message.interactive.response'
  ]);
</script>
          `;
      postscribe(targetElement, scriptContent);
    } else {
      console.error('Target element not found');
    }
  }, [targetElement]);


  // useEffect(()=>{
  //   RefreshAccount();
  // },[])


  // const next = (data) => {
  //   if (current < steps.length - 1) {
  //     if (productsFormRef?.current) {
  //       productsFormRef.current.completeStep();
  //     }

  //     if (current != 1 && current != 4 && current != 3) {
  //       setCurrent(current + 1);
  //     }
  //   } else if (current === steps.length - 1) {
  //     navigate("/confirmation");
  //   }
  // };

  const incrementCurrent = () => {
    if (current < steps.length - 1) {
      setCurrent(current + 1);
    } else if (current == steps.length - 1) {
      navigate("/confirmation");
    }
  };

  const prev = () => {
    if (current > 0) {
      setCurrent(current - 1);
    }
  };

  const StepContent = steps[current]?.content;

  const handleSkipButtonClick = () => {
    if (current > -1 && current < steps.length - 1) {
      setCurrent(current + 1);
    } else if (current == steps.length - 1) {
      navigate("/shipment");
    }
  };

  return (
    <>
      <div className="onboarding-steps-content-container">
        <div className="onboarding-steps-content">
          <div key={current}>
            {current == 1 ? (
              <Products
                onNext={next}
                ref={productsFormRef}
                onSuccess={incrementCurrent}
              />
            ) : current == 4 ? (
              <Users
                onNext={next}
                ref={productsFormRef}
                onSuccess={incrementCurrent}
              />
            ) : current == 3 ? (
              <LocationMap
                onNext={next}
                ref={productsFormRef}
                onSuccess={incrementCurrent}
              />
            ) : current == 5 ? (
              <NotificationsSetup
                form={form}
                onNext={next}
                ref={productsFormRef}
                onSuccess={incrementCurrent}
              />

            ) : // (current==5 ? <Notifications onNext={next}  ref={productsFormRef}  onSuccess={incrementCurrent}/>
              current == 0 ? (
                <Couriers onNext={next} />
              ) : (
                <Sensors onNext={next} />
              )}
          </div>
          {/* {current==1 ? <Products onNext={next}  ref={productsFormRef} /> : <StepContent onNext={next} />} */}
        </div>
      </div>

      <div className="custom-steps-container">
        <Flex
          className="custom-steps"
          justify="space-between"
          align="center"
          gap="large"
          style={{ height: "inherit" }}
        >
          {current > 0 ? (
            <CustomButton
              onClick={prev}
              text={"Back"}
              width="72px"
              height="48px"
              color="#000"
              fontSize="16px"
              bgColor="#F3F3F3"
              fontWeight="500"
              boxShadow="none"
            />
          ) : null}

          <Row className="custom-steps-row">
            <Col span={24}>
              <Steps current={current} labelPlacement="vertical">
                {steps.map((step, index) => (
                  <Step key={index} title={step.title} />
                ))}
              </Steps>
            </Col>
          </Row>

          <div className="steps-action">
            <Flex gap={12}>
              <CustomButton
                onClick={handleSkipButtonClick}
                text="Skip for now"
                width="125px"
                height="48px"
                color="#000"
                fontSize="16px"
                bgColor="inherit"
                fontWeight="500"
                boxShadow="none"
              />

              {
                // current < steps.length - 1 &&
                <CustomButton
                  onClick={next}
                  // text={current === steps.length - 1 ? "Finish" : "Next"}
                  text={"Next"}
                  width="223px"
                  height="48px"
                  color="#ffffff"
                  fontSize="16px"
                  bgColor="#000000"
                  fontWeight="500"
                  boxShadow="none"
                  className="next-btn"
                />
              }
            </Flex>
          </div>
        </Flex>
      </div>
    </>
  );
};

export default OnboardingSteps;
